import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Backdrop from "@mui/material/Backdrop";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import MDButton from "components/MDButton";
import WarningIcon from "@mui/icons-material/Warning";
import PropTypes from "prop-types";

function Warning({ open, onClose, title, message }) {
    const [showCard, setShowCard] = useState(false);

    useEffect(() => {
        if (open) {
            setShowCard(true);
        } else {
            const t = setTimeout(() => setShowCard(false), 300);
            return () => clearTimeout(t);
        }
    }, [open]);

    return (
        <Backdrop
            open={open || showCard}
            sx={{
                zIndex: (theme) => theme.zIndex.modal + 2,
                backgroundColor: "rgba(0, 0, 0, 0.8)",
            }}
        >
            <Slide direction="up" in={showCard} mountOnEnter unmountOnExit>
                <Card
                    sx={{
                        width: "100%",
                        maxWidth: 500,
                        p: 4,
                        textAlign: "center",
                        borderRadius: "16px",
                        backgroundColor: "white",
                        boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
                    }}
                >
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <WarningIcon sx={{ fontSize: 60, color: "#FFB800", mb: 2 }} />

                        <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
                            {title || "Warning"}
                        </Typography>

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            {message || "Something went wrong."}
                        </Typography>

                        <MDButton
                            variant="contained"
                            color="accent" // Or "accent" if that's the primary theme color
                            onClick={onClose}
                            sx={{ px: 3, py: 1.2, fontWeight: 600, width: "auto", minWidth: "180px", alignSelf: "center" }}
                        >
                            Got it
                        </MDButton>
                    </Box>
                </Card>
            </Slide>
        </Backdrop>
    );
}

Warning.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    message: PropTypes.string,
};

export default Warning;
